import { ChevronRight, Loader2 } from "lucide-react";

export function ToolCall({ text, toolName, isActive }: { text: string; toolName?: string; isActive?: boolean }) {
  if (isActive) {
    const label = toolName ? `Calling ${toolName}...` : "Calling tool...";
    return (
      <div className="flex items-center gap-1.5 text-[13px] text-gray-400 my-2 anim-fade-in pl-1">
        <Loader2 size={14} className="animate-spin text-gray-400" />
        <span>{label}</span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1.5 text-[13px] text-gray-500 my-2 anim-fade-in pl-1">
      <ChevronRight size={14} className="text-gray-400" /> <span>{text}</span>
    </div>
  );
}
